import { Timestamp } from "firebase/firestore";

export default function getIsoStringFromTimestamp(timestamp: Timestamp) {
  return timestamp.toDate().toISOString();
}
